import { createContext, useContext } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';

export type ThemePreferenceContextValue = {
  preference: ThemePreference;
  setPreference: (preference: ThemePreference) => void;
};

export const ThemePreferenceContext =
  createContext<ThemePreferenceContextValue | null>(null);
ThemePreferenceContext.displayName = 'ThemePreferenceContext';

export function useThemePreference() {
  const value = useContext(ThemePreferenceContext);
  if (!value) {
    throw new Error(
      'useThemePreference has to be used under ThemePreferenceProvider',
    );
  }
  return value;
}
